import React, { useState } from 'react';
import { Box, DialogTitle, Dialog, DialogContent, DialogActions, Alert, Button } from '@mui/material';
import { useFormikContext, Formik } from 'formik';
import DebounceTextField from '../../../components/DebounceTextfield';
import { AgentInputType } from '../../../types/AgentInputType.types';
import DismissedDialogValid from '../../../types/validSchemas/DismissedDialog.valid';

function AgentFormDismiss() {
  const { values: mainValues, setFieldValue } = useFormikContext<AgentInputType>();
  const [open, setOpen] = useState(false);

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleOpen = (): void => {
    setOpen(true);
  };

  return (
    <Box sx={{ paddingTop: '5%' }}>
      <Button
        onClick={() => {
          handleOpen();
        }}
        variant="contained"
        fullWidth
        disabled={!!mainValues.dismissed_at}
        color="error"
      >
        Berater Kündigen
      </Button>

      <Formik
        enableReinitialize
        validateOnMount
        initialValues={mainValues}
        onSubmit={(values) => {
          setFieldValue('dismissed_at', values.dismissed_at);
          setFieldValue('dismissal_reason', values.dismissal_reason);
        }}
        validationSchema={DismissedDialogValid}
      >
        {({ values, handleSubmit, handleChange, handleBlur, errors, isValid, resetForm, dirty }) => (
          <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
            <DialogTitle>Kündigung einstellen</DialogTitle>
            <DialogContent>
              <Box m={1} display="flex" flexDirection="column" minWidth="400px">
                <DebounceTextField
                  type="date"
                  label="Kündigungsdatum"
                  name="dismissed_at"
                  value={values.dismissed_at}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={errors.dismissed_at && errors.dismissed_at}
                  error={Boolean(errors.dismissed_at) || false}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Box>
              <Box>
                <DebounceTextField
                  label="Kündigungs Notiz"
                  name="dismissal_reason"
                  value={values.dismissal_reason || ''}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  variant="outlined"
                  multiline
                  rows={3}
                  helperText={errors.dismissal_reason && errors.dismissal_reason}
                  error={Boolean(errors.dismissal_reason) || false}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Alert variant="filled" severity="warning">
                  <div>Achtung: Alle Leistungen werden zum Monatsende des Kündigungsmonats geschlossen</div>
                  <div className="flex pl-1">
                    <div>{`Achtung: Statusänderung auf "gekündigt" erfolgt automatisch zum letzten Tag des Kündigungsmonats`}</div>
                  </div>
                </Alert>
              </Box>
            </DialogContent>
            <DialogActions disableSpacing={false}>
              <Button
                autoFocus
                onClick={() => {
                  resetForm();
                  handleClose();
                }}
                variant="outlined"
              >
                Abbrechen
              </Button>

              <Button
                onClick={() => {
                  handleSubmit();
                  handleClose();
                }}
                variant="outlined"
                disabled={!isValid || !dirty}
              >
                Setzen
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Formik>
    </Box>
  );
}

export default AgentFormDismiss;
